import { LOG_IN, LOG_OUT } from "../actions/account.actions";
import { IAccount } from "../models/IAccount";
import { IAccountState } from "../models/IAccountState";
import { IActionBase } from "../models/IActionBase";

const initialState: IAccountState = {
    account: {
        email: "",
        name: "",
        picture: "",
        isAuthenticated: false,
        isAuthenticationEnabled: false
    }
};

function accountReducer(state: IAccountState = initialState, action: IActionBase): IAccountState {
    switch (action.type) {
        case LOG_IN: {
            // If the authentication is not enabled it sets the isAuthenticated to true, otherwise uses the result from the API.
            const isAuthenticated = action.account.isAuthenticationEnabled ? action.account.isAuthenticated : true;
            const loggedInAccount: IAccount = {
                email: action.account.email,
                name: action.account.name,
                picture: action.account.picture,
                isAuthenticated: isAuthenticated,
                isAuthenticationEnabled: action.account.isAuthenticationEnabled
            };

            return {
                ...state,
                account: loggedInAccount  
            };
        }
        case LOG_OUT: {
            return initialState;
        }
        default:
            return state;
    }
}

export default accountReducer;